import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import $ from 'jquery';

function CspIndoNepal() {
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.data);
  const [errors, setErrors] = useState(false);
  const [cspMobile, setCspMobile] = useState(false);
  const [data, setData] = useState(false);
  const [cspData, setCspData] = useState(false);
  const [senderData, setSenderData] = useState(false);
  const [processId, setProcessId] = useState('');
  const [transferData, setTransferData] = useState(false);
  const [partnerUniqueRefNo, setPartnerUniqueRefNo] = useState(false);
  const [tokenData, setTokenData] = useState(false);
  const [searchBy, setSearchBy] = useState("mobile");
  const [showModal, setShowModal] = useState(false);
  const [localStates, setLocalStates] = useState(false);
  const [localDistricts, setLocalDistricts] = useState(false);
  const [shopStates, setShopStates] = useState(false);
  const [shopDistricts, setShopDistricts] = useState(false);
  const [localCity, setLocalCity] = useState(false);
  const [shopCity, setShopCity] = useState(false);
  const [courseData, setCourseData] = useState(false);
  const handleClose = () => {
    setShowModal(false);
    setErrors(false);
  }

  const handleShow = () => {
    setErrors(false);
    setShowModal(true);
  }

  const resetStates = () => {
    setErrors(false);
    setCspMobile(false);
    setData(false);
    setCspData(false);
    setSenderData(false);
    setProcessId("");
    setTransferData(false);
    setPartnerUniqueRefNo(false);
    setTokenData(false);
    setSearchBy("mobile");
    setShowModal(false);
    //setLocalStates(false);
    //setLocalDistricts(false);
    //setShopStates(false);
    //setShopDistricts(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    let jsonData = {};
    let errorData = {};
    Array.from(form.elements).forEach((item) => {
      if (item.name) {
        if (item.value == "" && item.getAttribute("requiredField")) {
          errorData[item.name] = [addSpaceBetweenCases(item.name)] + " is required";
        }
        jsonData[item.name] = item.value;
      }
    });
    if (Object.entries(errorData).length > 0) {
      setErrors(errorData);
    }
    else {
      try {
        if (!cspData) {
          jsonData['BranchCode'] = data?.BranchCode;
          const response = await axios.post('/csp/customer/onboarding', jsonData);
          const { StatusCode, ResponseMessage } = response.data;
          toast(ResponseMessage);
          if (ResponseMessage == "Aadhaarrefkey not generated.") {
            const response1 = await axios.post('/csp/customer/bioKYCRequery', jsonData);
            toast(response1.data.ResponseMessage);
          }
          resetStates();
        }
        else {
          if (!jsonData?.otp) {
            setSenderData(jsonData);
            const response = await axios.post('/v2/remittance/send/csp/otp', {
              mobile_number: jsonData?.MobileNumber,
              csp_name: [jsonData?.FirstName, jsonData?.MiddleName, jsonData?.LastName].filter(Boolean).join(" ")
            });
            const { ProcessId, message } = response.data.data;
            setProcessId(ProcessId);
            toast(message);
          }
          else {
            let data = { ...senderData, OTP: jsonData?.otp, OTPProcessId: processId };
            const response = await axios.post('/csp/customer/create', data);
            const { StatusCode, ResponseMessage } = response.data;
            if (StatusCode == "200") {
              setShowModal(false);
            }
            toast(ResponseMessage);
          }
        }
      } catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
  };
  const verifyKyc = async () => {
    try {
      const response = await axios.post('/csp/customer/initiate', { MobileNumber: data?.MobileNumber, BranchCode: data?.BranchCode });
      const { StatusCode, ResponseMessage, Url, PartnerUniqueRefNo, tokenData } = response.data;
      if (StatusCode == "0") {
        toast(ResponseMessage);
      }
      else {
        setPartnerUniqueRefNo(PartnerUniqueRefNo);
        setTokenData(tokenData);
        window.open(Url, '_blank');
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  const onBoarding = async () => {
    setShowModal(true);
    try {
      // const response = await axios.post('/csp/customer/onboarding', { ...data });
      // const { StatusCode, ResponseMessage } = response.data;
      // toast(ResponseMessage);
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  const otpConsent = async () => {
    try {
      const response = await axios.post('/csp/customer/AgentConsent', { ...data });
      const { StatusCode, ResponseMessage, OTPConsentStatus, Remarks } = response.data;
      toast(ResponseMessage);
      if (StatusCode == "1") {
        if (OTPConsentStatus == "Pending" || (Remarks && Remarks == "OTP Consent Pending")) {
          window.open("https://uid.rbl.bank.in/CustomerLogin/PPIAgentEkyc.aspx?ref=2DolbGEO4/Qe8Os111Jtig==", '_blank');
        }
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  }
  const handleSearch = async (e) => {
    e.preventDefault();
    resetStates();
    const { mobile } = e.target;
    const isValid = /^\d{10}$/.test(mobile.value);
    if (!isValid) {
      setErrors({ mobile: "Mobile should be 10 number" });
    }
    else {
      setErrors(false);
      setCspMobile(mobile.value);
      try {
        const response = await axios.post("/csp/customer/search", { MobileNumber: mobile.value });
        const { StatusCode, ResponseMessage, CSPDetail } = response.data;
        if (StatusCode) {
          if (CSPDetail.length > 0) {
            setData(CSPDetail[0]);
            setLocalCity(CSPDetail[0].LocalCity);
            setShopCity(CSPDetail[0].ShopCity);
            if (CSPDetail[0].LocalState) {
              let e = { target: { value: CSPDetail[0].LocalState } };
              getLocalDistrictData(e);
            }
            if (CSPDetail[0].ShopState) {
              let e = { target: { value: CSPDetail[0].ShopState } };
              getShopDistrictData(e);
            }
          }
          else {
            toast(ResponseMessage);
            setCspData(true);
          }
        }
        else {
          toast(ResponseMessage);
        }
      } catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
  };

  const getLocalStateData = async (country) => {
    try {
      const response = await axios.post('/v2/remittance/get/states', { country });
      const { status } = response.data;
      if (status) {
        setLocalStates(response.data.data);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const getLocalDistrictData = async (e) => {
    deleteError(e);
    try {
      const response = await axios.post('/v2/remittance/get/district', { state: e.target.value });
      const { status } = response.data;
      if (status) {
        setLocalDistricts(response.data.data);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const getLocalCity = (e) => {
    deleteError(e);
    setLocalCity(e.target.value);
  };

  const getShopStateData = async (country) => {
    try {
      const response = await axios.post('/v2/remittance/get/states', { country });
      const { status } = response.data;
      if (status) {
        setShopStates(response.data.data);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const getShopDistrictData = async (e) => {
    deleteError(e);
    try {
      const response = await axios.post('/v2/remittance/get/district', { state: e.target.value });
      const { status } = response.data;
      if (status) {
        setShopDistricts(response.data.data);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const getShopCity = (e) => {
    deleteError(e);
    setShopCity(e.target.value);
  };

  const getCourseData = (e) => {
    deleteError(e);
    setCourseData(e.target.value);
  };

  const convertToDateFormat = (dob) => {
    const [month, day, year] = dob.split('/');
    if (month && day && year) {
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
  };

  const captureFinger = async (e) => {
    e.preventDefault();
    const finalUrl = "https://127.0.0.1:11100/rd/capture";
    const XML = `<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts fCount="1" fType="2" iCount="0" pCount="0" pgCount="2" format="0"   pidVer="2.0" timeout="10000" pTimeout="20000" wadh="TF/lfPuh1n4ZY1xizYpqikIBm+gv65r51MFNek4uwNw=" posh="UNKNOWN" env="P" /> <CustOpts><Param name="mantrakey" value="" /></CustOpts> </PidOptions>`;
    try {
      $.ajax({
        type: "CAPTURE",
        async: false,
        crossDomain: true,
        url: finalUrl,
        data: XML,
        contentType: "text/xml; charset=utf-8",
        processData: false,
        success: async function (resData) {
          var $doc = $.parseXML(resData);
          var pid = $($doc).find("Data").text();
          var errcode = $($doc).find("Resp").attr("errCode");
          var errinfo = $($doc).find("Resp").attr("errInfo");
          var skey = $($doc).find("Skey").text();
          var ci = parseInt($($doc).find("Skey").attr("ci"));
          var hmac = $($doc).find("Hmac").text();
          var type = $($doc).find("Data").attr("type");
          var dpId = $($doc).find("DeviceInfo").attr("dpId");
          var rdsId = $($doc).find("DeviceInfo").attr("rdsId");
          var rdsVer = $($doc).find("DeviceInfo").attr("rdsVer");
          var dc = $($doc).find("DeviceInfo").attr("dc");
          var mi = $($doc).find("DeviceInfo").attr("mi");
          var mc = $($doc).find("DeviceInfo").attr("mc");
          let data1 = {
            pid, errcode, errinfo, skey, ci, hmac, type, dpId, rdsId, rdsVer, dc, mi, mc
          };
          try {
            let response = await axios.post('/csp/customer/enrollment', { ...data, ...data1, PartnerUniqueRefNo: partnerUniqueRefNo, tokenData, BranchCode: data?.BranchCode });
            const { status, message } = response.data;
            if (!status) {
              toast(message);
            }
            else {
              toast(message);
            }
          }
          catch (error) {
            if (error?.response?.data?.message) {
              toast(error.response.data.message);
            }
          }
        },
        error: function (jqXHR, ajaxOptions, thrownError) {
          toast(getHttpError(jqXHR));
        },
      });
    } catch (error) {
      toast(getHttpError(error));
    }
  };

  const getHttpError = (error) => {
    let err = "Unhandled Exception";
    if (!error.response) {
      err = 'Service Unavailable';
    } else if (error.response.status === 404) {
      err = 'Requested page not found';
    } else if (error.response.status === 500) {
      err = 'Internal Server Error';
    } else if (error.message === 'timeout') {
      err = 'Time out error';
    } else if (error.message === 'abort') {
      err = 'Ajax request aborted';
    } else {
      err = 'Unhandled Error';
    }
    return err;
  };

  function addSpaceBetweenCases(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1 $2');
  };
  const deleteError = (e) => {
    const errorKey = e.target.name;
    if (errorKey) {
      const updatedErrors = { ...errors };
      delete updatedErrors[errorKey];
      setErrors(updatedErrors);
      setData({ ...data, [e.target.name]: e.target.value });
    }
  };
  useEffect(() => {
    getLocalStateData("India");
    getShopStateData("India");
  }, []);

  useEffect(() => {
    if (currentUser && currentUser.prabhuCspOnboarding == false) {
      navigate('/admin/dashboard');
    }
  }, [currentUser]);

  return (
    <div class="content-wrapper">
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Search Sender</h4>
              <form className="searchForm" onSubmit={handleSearch}>
                <div className="row">
                  <div class="col-lg-4 col-md-4">
                    <label>Search By</label>
                    <select class="form-control" name="search_by" onChange={(e) => setSearchBy(e.target.value)}>
                      <option value="mobile">Mobile Number</option>
                      <option value="id">ID Number</option>
                    </select>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    {
                      searchBy == "id" ? (
                        <>
                          <label>ID Number</label>
                          <input class="form-control" type="number" name="id_number" required />
                        </>
                      ) : (
                        <>
                          <label>Mobile</label>
                          <input class="form-control" type="number" name="mobile" />
                          <span className="error">{errors && errors?.mobile}</span>
                        </>
                      )
                    }
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <input type="submit" className="search-btn btn btn-primary" value="Search" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              {
                cspData ? (
                  <>
                    <h4 class="card-title">
                      CSP Data
                    </h4>
                    <div className="emptyCSP">
                      <h4>Mobile number not exist in CSP</h4>
                      <div>
                        <button className="btn btn-primary" onClick={handleShow}>Create CSP</button>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    {
                      data && (
                        <>
                          <h4 class="card-title">
                            CSP Data
                          </h4>
                          <ul className="showData">
                            {Object.entries(data).map(([key, value]) => (
                              (value != "" && value != null) && (
                                <li key={key}>
                                  <strong>{addSpaceBetweenCases(key)}:</strong>
                                  <div>{value}</div>
                                </li>
                              )
                            ))}
                          </ul>
                          <div className="pt-3">
                            {
                              (data.EKYAStatus == "UnVerified") ? (
                                (partnerUniqueRefNo && tokenData) ? (
                                  <form onSubmit={captureFinger}>
                                    <div class="row justify-content-center">
                                      <button class="btn btn-primary" type="submit">Capture Finger</button>
                                    </div>
                                  </form>
                                ) : (
                                  <>
                                    <h4>EKYC is not verified</h4>
                                    <div><button className="btn btn-primary" onClick={verifyKyc}>Verify Now</button></div>
                                  </>
                                )
                              ) : (data.RBLOnboardingStatus == "Pending") ? (
                                <>
                                  <h4>You are not onboarded</h4>
                                  <div><button className="btn btn-primary" onClick={onBoarding}>Onboard Now</button></div>
                                </>
                              ) : (data.OTPConsentStatus == "Pending") && (
                                <>
                                  <h4>You are not eligible for OTP Consent</h4>
                                  <div><button className="btn btn-primary" onClick={otpConsent}>OTP Consent Now</button></div>
                                </>
                              )
                            }
                          </div>
                        </>
                      )
                    }
                  </>
                )
              }
            </div>
          </div>
        </div>
      </div>
      {/* Modal component */}
      <Modal show={showModal} onHide={handleClose} centered size={'xl'} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>{!cspData ? "Onboard CSP" : "Create New CSP"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            {
              processId == "" ? (
                <div class="row justify-content-center">
                  <div class="col-md-12">
                    <div className="row">
                      <div class="col-lg-4 col-md-4">
                        <label>Partner ID Code</label>
                        <input class="form-control" type="text" name="PartnerIDCode" value={data?.PartnerIDCode} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.PartnerIDCode}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>First Name</label>
                        <input class="form-control" type="text" name="FirstName" value={data?.FirstName} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.FirstName}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Middle Name</label>
                        <input class="form-control" type="text" name="MiddleName" value={data?.MiddleName} />
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Last Name</label>
                        <input class="form-control" type="text" name="LastName" value={data?.LastName} />
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Company Name</label>
                        <input class="form-control" type="text" name="CompanyName" value={data?.CompanyName} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.CompanyName}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Mobile Number</label>
                        <input class="form-control" type="text" name="MobileNumber" value={cspMobile && cspMobile} requiredField="true" readonly />
                        <span className="error">{errors && errors?.MobileNumber}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Local Address</label>
                        <input class="form-control" type="text" name="LocalAddress" value={data?.LocalAddress} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.LocalAddress}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Local State</label>
                        <select class="form-control" name="LocalState" value={data?.LocalState} onChange={getLocalDistrictData} requiredField="true">
                          <option value="">--State--</option>
                          {localStates && localStates.map((state, index) => (
                            <option value={state}>
                              {state}
                            </option>
                          ))}
                        </select>
                        <span className="error">{errors && errors?.LocalState}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Local District</label>
                        <select class="form-control" name="LocalDistrict" value={data?.LocalDistrict} onChange={getLocalCity} requiredField="true">
                          <option value="">--Select--</option>
                          {localDistricts && localDistricts.map((district, index) => (
                            <option value={district}>
                              {district}
                            </option>
                          ))}
                        </select>
                        <span className="error">{errors && errors?.LocalDistrict}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Local City</label>
                        <select class="form-control" name="LocalCity" value={data?.LocalCity} onChange={deleteError} requiredField="true">
                          <option value="">--Select--</option>
                          {localCity && (
                            <option value={localCity}>
                              {localCity}
                            </option>
                          )}
                        </select>
                        <span className="error">{errors && errors?.LocalCity}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Local Area</label>
                        <input class="form-control" type="text" name="LocalArea" value={data?.LocalArea} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.LocalArea}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Local Pin Code</label>
                        <input class="form-control" type="text" name="LocalPinCode" value={data?.LocalPinCode} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.LocalPinCode}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Telephone</label>
                        <input class="form-control" type="text" name="Telephone" value={data?.Telephone} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.Telephone}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Alternate Number</label>
                        <input class="form-control" type="text" name="AlternateNumber" value={data?.AlternateNumber} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.AlternateNumber}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Email Id</label>
                        <input class="form-control" type="email" name="EmailId" value={data?.EmailId} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.EmailId}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>DOB</label>
                        <input class="form-control" type="date" name="DOB" value={data?.DOB && convertToDateFormat(data?.DOB)} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.DOB}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Pan Card</label>
                        <input class="form-control" type="text" name="PanCard" value={data?.PanCard} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.PanCard}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Shop Address</label>
                        <input class="form-control" type="text" name="ShopAddress" value={data?.ShopAddress} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.ShopAddress}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Shop State</label>
                        <select class="form-control" name="ShopState" value={data?.ShopState} onChange={getShopDistrictData} requiredField="true">
                          <option value="">--State--</option>
                          {shopStates && shopStates.map((state, index) => (
                            <option value={state}>
                              {state}
                            </option>
                          ))}
                        </select>
                        <span className="error">{errors && errors?.ShopState}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Shop District</label>
                        <select class="form-control" name="ShopDistrict" value={data?.ShopDistrict} onChange={getShopCity} requiredField="true">
                          <option value="">--Select--</option>
                          {shopDistricts && shopDistricts.map((district, index) => (
                            <option value={district}>
                              {district}
                            </option>
                          ))}
                        </select>
                        <span className="error">{errors && errors?.ShopDistrict}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Shop City</label>
                        <select class="form-control" name="ShopCity" value={data?.ShopCity} onChange={deleteError} requiredField="true">
                          <option value="">--Select--</option>
                          {shopCity && (
                            <option value={shopCity}>
                              {shopCity}
                            </option>
                          )}
                        </select>
                        <span className="error">{errors && errors?.ShopCity}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Shop Area</label>
                        <input class="form-control" type="text" name="ShopArea" value={data?.ShopArea} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.ShopArea}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Shop PinCode</label>
                        <input class="form-control" type="text" name="ShopPinCode" value={data?.ShopPinCode} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.ShopPinCode}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>IFSC Code</label>
                        <input class="form-control" type="text" name="IFSCCode" value={data?.IFSCCode} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.IFSCCode}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Account Number</label>
                        <input class="form-control" type="text" name="AccountNumber" value={data?.AccountNumber} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.AccountNumber}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Agent Account Name</label>
                        <input class="form-control" type="text" name="AgentAccountName" value={data?.AgentAccountName} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.AgentAccountName}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Gender</label>
                        <select class="form-control" name="Gender" value={data?.Gender} onChange={deleteError} requiredField="true">
                          <option value="">--Select--</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Other</option>
                        </select>
                        <span className="error">{errors && errors?.Gender}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Category</label>
                        <select class="form-control" name="Category" value={data?.Category} onChange={deleteError} requiredField="true">
                          <option value="">--Select--</option>
                          <option value="General">General</option>
                          <option value="OBC">OBC</option>
                          <option value="ST">ST</option>
                          <option value="SC">SC</option>
                        </select>
                        <span className="error">{errors && errors?.Category}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Father Name Or Spouse Name</label>
                        <input class="form-control" type="text" name="FatherNameOrSpouseName" value={data?.FatherNameOrSpouseName} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.FatherNameOrSpouseName}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Physically Handicapped</label>
                        <select class="form-control" name="PhysicallyHandicapped" value={data?.PhysicallyHandicapped} onChange={deleteError} requiredField="true">
                          <option value="">--Select--</option>
                          <option value="Handicapped">Handicapped</option>
                          <option value="Not Handicapped">Not Handicapped</option>
                        </select>
                        <span className="error">{errors && errors?.PhysicallyHandicapped}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Alternate Occupation Type</label>
                        <select class="form-control" name="AlternateOccupationType" value={data?.AlternateOccupationType} onChange={deleteError} requiredField="true">
                          <option value="">--Select--</option>
                          <option value="Government">Government</option>
                          <option value="Self Employed">Self Employed</option>
                          <option value="Public Sector">Public Sector</option>
                          <option value="Private">Private</option>
                          <option value="Other">Other</option>
                          <option value="None">None</option>
                        </select>
                        <span className="error">{errors && errors?.AlternateOccupationType}</span>
                      </div>
                      {/* <div class="col-lg-4 col-md-4">
                        <label>Alternate Occupation Description</label>
                        <input class="form-control" type="text" name="AlternateOccupationDescription" value={data?.AlternateOccupationDescription} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.AlternateOccupationDescription}</span>
                      </div> */}
                      <div class="col-lg-4 col-md-4">
                        <label>Highest Education Qualification</label>
                        <select class="form-control" name="HighestEducationQualification" value={data?.HighestEducationQualification} onChange={deleteError} requiredField="true">
                          <option value="">--Select--</option>
                          <option value="Under 10th">Under 10th</option>
                          <option value="10th">10th</option>
                          <option value="12th">12th</option>
                          <option value="Graduate">Graduate</option>
                          <option value="Post Graduate">Post Graduate</option>
                        </select>
                        <span className="error">{errors && errors?.HighestEducationQualification}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Corporate Individual BC</label>
                        <select class="form-control" name="CorporateIndividualBC" value={data?.CorporateIndividualBC} onChange={deleteError} requiredField="true">
                          <option value="">--Select--</option>
                          <option value="Corporate">Corporate</option>
                          <option value="Individual">Individual</option>
                        </select>
                        <span className="error">{errors && errors?.CorporateIndividualBC}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Course</label>
                        <select class="form-control" name="Course" value={data?.Course} onChange={getCourseData} requiredField="true">
                          <option value="">--Select--</option>
                          <option value="IIBF Advance">IIBF Advance</option>
                          <option value="IIBF Basic">IIBF Basic</option>
                          <option value="Certified by Bank">Certified by Bank</option>
                          <option value="None">None</option>
                        </select>
                        <span className="error">{errors && errors?.Course}</span>
                      </div>
                      {
                        (courseData != "None" && data?.Course != "None") && (
                          <>
                            <div class="col-lg-4 col-md-4">
                              <label>Date Of Passing</label>
                              <input class="form-control" type="date" name="DateOfPassing" value={data?.DateOfPassing} onChange={deleteError} requiredField="true" />
                              <span className="error">{errors && errors?.DateOfPassing}</span>
                            </div>
                            <div class="col-lg-4 col-md-4">
                              <label>Institute Name</label>
                              <input class="form-control" type="text" name="InstituteName" value={data?.InstituteName} onChange={deleteError} requiredField="true" />
                              <span className="error">{errors && errors?.InstituteName}</span>
                            </div>
                          </>
                        )
                      }
                      <div class="col-lg-4 col-md-4">
                        <label>Device Name</label>
                        <input class="form-control" type="text" name="DeviceName" value={data?.DeviceName} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.DeviceName}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Connectivity Type</label>
                        <select class="form-control" name="ConnectivityType" value={data?.ConnectivityType} onChange={deleteError} requiredField="true">
                          <option value="">--Select--</option>
                          <option value="Landline">Landline</option>
                          <option value="Mobile">Mobile</option>
                          <option value="VSAT">VSAT</option>
                        </select>
                        <span className="error">{errors && errors?.ConnectivityType}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Provider</label>
                        <select class="form-control" name="Provider" value={data?.Provider} onChange={deleteError} requiredField="true">
                          <option value="">--Select--</option>
                          <option value="Airtel">Airtel</option>
                          <option value="JIO">JIO</option>
                        </select>
                        <span className="error">{errors && errors?.Provider}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Entity Type</label>
                        <select class="form-control" name="EntityType" value={data?.EntityType} onChange={deleteError} requiredField="true">
                          <option value="">--Select--</option>
                          <option value="Sole Proprietor">Sole Proprietor</option>
                          <option value="Individual">Individual</option>
                        </select>
                        <span className="error">{errors && errors?.EntityType}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Weekly Off</label>
                        <select class="form-control" name="WeeklyOff" value={data?.WeeklyOff} onChange={deleteError} requiredField="true">
                          <option value="">--Select--</option>
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </select>
                        <span className="error">{errors && errors?.WeeklyOff}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Bank Name</label>
                        <input class="form-control" type="text" name="BankName" value={data?.BankName} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.BankName}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Branch Name</label>
                        <input class="form-control" type="text" name="BranchName" value={data?.BranchName} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.BranchName}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>List Of Other Banks The CSP Works With</label>
                        <input class="form-control" type="text" name="ListOfOtherBanksTheCSPWorksWith" value={data?.ListOfOtherBanksTheCSPWorksWith} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.ListOfOtherBanksTheCSPWorksWith}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Nature Of Business</label>
                        <input class="form-control" type="text" name="NatureOfBusiness" value={data?.NatureOfBusiness} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.NatureOfBusiness}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Expected Annual Turnover</label>
                        <input class="form-control" type="text" name="ExpectedAnnualTurnover" value={data?.ExpectedAnnualTurnover} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.ExpectedAnnualTurnover}</span>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <label>Expected Annual Income</label>
                        <input class="form-control" type="text" name="ExpectedAnnualIncome" value={data?.ExpectedAnnualIncome} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.ExpectedAnnualIncome}</span>
                      </div>
                      {/* <div class="col-lg-4 col-md-4">
                        <label>Branch Code</label>
                        <input class="form-control" type="text" name="BranchCode" value={data?.BranchCode} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.BranchCode}</span>
                      </div> */}
                      <div class="col-lg-12 col-md-12">
                        <button class="search-btn btn btn-primary" type="submit">{!cspData ? "Onboard" : "Send OTP"}</button>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div class="row justify-content-center">
                  <div class="col-md-12">
                    <div className="row">
                      <div class="col-lg-6 col-md-6">
                        <label>OTP</label>
                        <input class="form-control" type="number" name="otp" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.otp}</span>
                      </div>
                      <div class="col-lg-6 col-md-6">
                        <button class="search-btn btn btn-primary" type="submit">Create CSP</button>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default CspIndoNepal;
